// 더미데이터 복구 시: 'react'에 useMemo·useState, 'react-router-dom'에 Link,
// animationVariants에 sectionStagger 를 다시 추가하고 아래 주석 블록을 해제하세요.
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/layout/Navbar';
import Footerbar from '../components/layout/Footerbar';
import PageTopIntroLine from '../components/layout/PageTopIntroLine';
import '../styles/PageTopIntro.css';
import '../styles/Portfolio.css';
import ARBackground from '../components/animations/ARBackground';
import WorkDetailModal from '../components/sections/WorkDetailModal';
import { useWindowScrollProgressRef } from '../hooks/useWindowScrollProgressRef';
import { AURA_PORTFOLIO_ITEMS } from '../data/auraPortfolioItems';
import { WORK_ITEMS } from '../data/workItems';
import {
  fadeUpItem,
  revealViewport,
  sectionStagger,
} from '../components/animations/animationVariants';

// 더미데이터 임시 비공개 (준비중) — 추후 복구 예정
// const FILTERS = [
//   { id: 'all', label: '전체' },
//   { id: 'project', label: '프로젝트' },
//   { id: 'review', label: '후기' },
// ];

const Portfolio = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const bgScrollRef = useWindowScrollProgressRef();
  // 상세 모달로 열어 볼 Work 항목 (null 이면 닫힘)
  const [activeWork, setActiveWork] = useState(null);
  // 더미데이터 임시 비공개 (준비중) — 추후 복구 예정
  // const [filter, setFilter] = useState('all');

  // const visibleItems = useMemo(() => {
  //   if (filter === 'all') return AURA_PORTFOLIO_ITEMS;
  //   return AURA_PORTFOLIO_ITEMS.filter((item) => item.kind === filter);
  // }, [filter]);

  useEffect(() => {
    const openId = location.state?.openWorkId;
    if (!openId) return;
    const item = AURA_PORTFOLIO_ITEMS.find((i) => i.id === openId);
    if (item) {
      navigate(`/work/${openId}`, { replace: true, state: {} });
    } else {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, navigate]);

  const handleAuraClick = () => {
    navigate('/aura');
  };

  return (
    <>
      <ARBackground scrollProgressRef={bgScrollRef} />
      <Navbar />
      <header className="page-top-intro">
        <PageTopIntroLine text="Aura 프로젝트·현장 후기" />
      </header>

      <section className="portfolio-content portfolio-content--article">
        <motion.header
          className="portfolio-hero"
          variants={fadeUpItem}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
        >
          <span className="section-eyebrow">Work / Showcase</span>
          <h2 className="portfolio-page-heading">
            Work<em className="portfolio-page-heading__dot">.</em>
          </h2>
          <p className="portfolio-page-lead">
            Aura로 함께한 프로젝트와 현장의 후기입니다. 항목을 누르면 진행 과정을 자세히 볼 수 있습니다.
          </p>
        </motion.header>

        {/* 더미데이터 임시 비공개 (준비중) — 추후 복구 예정
        <motion.div
          className="portfolio-filter-row"
          role="tablist"
          aria-label="목록 필터"
          variants={fadeUpItem}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
        >
          <div className="portfolio-filter-chips">
            {FILTERS.map((f) => (
              <button
                key={f.id}
                type="button"
                role="tab"
                aria-selected={filter === f.id}
                className={
                  filter === f.id
                    ? 'portfolio-filter-chip portfolio-filter-chip--active'
                    : 'portfolio-filter-chip'
                }
                onClick={() => setFilter(f.id)}
              >
                {f.label}
              </button>
            ))}
          </div>
          <span className="portfolio-filter-count" aria-live="polite">
            {String(visibleItems.length).padStart(2, '0')} items
          </span>
        </motion.div>

        <motion.ul
          key={filter}
          className="portfolio-article-list"
          variants={sectionStagger}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
        >
          {visibleItems.map((item, index) => (
            <motion.li key={item.id} variants={fadeUpItem}>
              <Link
                to={`/work/${item.id}`}
                className="portfolio-article-row"
              >
                <span className="portfolio-article-row__index" aria-hidden="true">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className="portfolio-article-row__thumb">
                  <img src={item.image} alt="" loading="lazy" />
                </div>
                <div className="portfolio-article-row__body">
                  <div className="portfolio-article-card__meta">
                    <span
                      className={
                        item.kind === 'review'
                          ? 'portfolio-article-tag portfolio-article-tag--review'
                          : 'portfolio-article-tag'
                      }
                    >
                      {item.tag}
                    </span>
                    <time className="portfolio-article-date" dateTime={item.date}>
                      {item.date}
                    </time>
                  </div>
                  <h3 className="portfolio-article-title">{item.title}</h3>
                  <p
                    className={
                      item.kind === 'review'
                        ? 'portfolio-article-excerpt portfolio-article-excerpt--quote'
                        : 'portfolio-article-excerpt'
                    }
                  >
                    {item.excerpt}
                  </p>
                </div>
                <span className="portfolio-article-row__arrow" aria-hidden="true">→</span>
              </Link>
            </motion.li>
          ))}
        </motion.ul>
        */}

        {/* 실제 진행한 프로젝트·전시 목록 — 클릭 시 상세 모달 표시 */}
        <motion.ul
          className="portfolio-article-list"
          variants={sectionStagger}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
        >
          {WORK_ITEMS.map((item, index) => (
            <motion.li key={item.id} variants={fadeUpItem}>
              <button
                type="button"
                className="portfolio-article-row"
                onClick={() => setActiveWork(item)}
              >
                <span className="portfolio-article-row__index" aria-hidden="true">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className="portfolio-article-row__thumb">
                  <img src={item.image} alt="" loading="lazy" />
                </div>
                <div className="portfolio-article-row__body">
                  <div className="portfolio-article-card__meta">
                    <span
                      className={
                        item.kind === 'review'
                          ? 'portfolio-article-tag portfolio-article-tag--review'
                          : 'portfolio-article-tag'
                      }
                    >
                      {item.tag}
                    </span>
                    <time className="portfolio-article-date" dateTime={item.date}>
                      {item.date}
                    </time>
                  </div>
                  <h3 className="portfolio-article-title">{item.title}</h3>
                  <p
                    className={
                      item.kind === 'review'
                        ? 'portfolio-article-excerpt portfolio-article-excerpt--quote'
                        : 'portfolio-article-excerpt'
                    }
                  >
                    {item.excerpt}
                  </p>
                </div>
                <span className="portfolio-article-row__arrow" aria-hidden="true">→</span>
              </button>
            </motion.li>
          ))}
        </motion.ul>

        <motion.div
          className="portfolio-coming-soon"
          variants={fadeUpItem}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
        >
          <span className="portfolio-coming-soon__eyebrow">Coming Soon</span>
          <p className="portfolio-coming-soon__title">
            새로운 작업물을 준비하고 있어요
          </p>
          <p className="portfolio-coming-soon__text">
            Aura와 함께한 프로젝트와 현장의 이야기를 곧 이곳에서 만나보실 수 있습니다.
          </p>
        </motion.div>

        <motion.div
          className="cta-button"
          variants={fadeUpItem}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
        >
          <button type="button" onClick={handleAuraClick}>
            Aura 플랫폼 보기
          </button>
        </motion.div>
      </section>

      <WorkDetailModal item={activeWork} onClose={() => setActiveWork(null)} />

      <Footerbar />
    </>
  );
};

export default Portfolio;
